import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/carriers'
export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
  get: async (id, req, opts) => RestApi.request('GET', srvcEndpoint, id, req, opts),
  store: async (data, opts) => RestApi.request('POST', srvcEndpoint, data, opts),
  update: async (id, data, opts) => RestApi.request('PUT', srvcEndpoint, id, data, opts),
  delete: async (id, opts) => RestApi.request('DELETE', srvcEndpoint, id, opts),

  uploadLogo: async (id, req, opts) =>
    RestApi.request('POST', srvcEndpoint, id, req, {
      endpoint: `/${id}/upload-logo`,
    }),
  getWithPriorities: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, { endpoint: `/priorities` }),
  getWithCoverageCategory: async (req, opts) =>
    RestApi.request('GET', srvcEndpoint, req, {
      endpoint: `/coverage-category`,
    }),
}
